document.documentElement.classList.remove('no-js');
const menuButton = document.querySelector('.menu-button');
const siteNav = document.querySelector('#SiteNav');
if (menuButton && siteNav) {
  menuButton.addEventListener('click', () => {
    const open = menuButton.getAttribute('aria-expanded') === 'true';
    menuButton.setAttribute('aria-expanded', String(!open));
    siteNav.classList.toggle('is-open', !open);
  });
}

const variantSelect = document.querySelector('#VariantSelect');
const quantityInput = document.querySelector('#Quantity');
const inventoryMessage = document.querySelector('.inventory-limit');
if (variantSelect && quantityInput) {
  const syncInventoryLimit = () => {
    const available = variantSelect.selectedOptions[0]?.dataset.inventory;
    if (available !== undefined) {
      const limit = Math.max(0, Number(available));
      quantityInput.max = String(limit);
      if (Number(quantityInput.value) > limit) quantityInput.value = String(Math.max(1, limit));
      if (inventoryMessage) inventoryMessage.textContent = limit > 0 ? `Only ${limit} available` : 'Sold out';
    } else {
      quantityInput.removeAttribute('max');
      if (inventoryMessage) inventoryMessage.textContent = '';
    }
  };
  variantSelect.addEventListener('change', syncInventoryLimit);
  quantityInput.addEventListener('change', () => {
    if (quantityInput.max && Number(quantityInput.value) > Number(quantityInput.max)) quantityInput.value = quantityInput.max;
  });
  syncInventoryLimit();
}

const drawerSection = () => document.querySelector('#shopify-section-cart-drawer');
const openCartDrawer = () => {
  document.body.classList.add('cart-drawer-open');
  document.querySelector('.cart-drawer')?.focus();
};
const closeCartDrawer = () => document.body.classList.remove('cart-drawer-open');
const refreshCartDrawer = async () => {
  const response = await fetch('/?sections=cart-drawer');
  const sections = await response.json();
  const holder = document.createElement('div');
  holder.innerHTML = sections['cart-drawer'];
  const fresh = holder.querySelector('#shopify-section-cart-drawer');
  const current = drawerSection();
  if (fresh && current) current.innerHTML = fresh.innerHTML;
  const cartResponse = await fetch('/cart.js');
  const cart = await cartResponse.json();
  document.querySelectorAll('.cart-count').forEach((badge) => { badge.textContent = cart.item_count; });
  document.querySelectorAll('.cart-link').forEach((link) => { link.setAttribute('aria-label', `Your Tiny Treasures, ${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'}`); });
};

document.addEventListener('click', async (event) => {
  const cartLink = event.target.closest('.cart-link');
  if (cartLink && !event.ctrlKey && !event.metaKey) {
    event.preventDefault();
    openCartDrawer();
    return;
  }
  if (event.target.closest('[data-cart-close]')) {
    closeCartDrawer();
    return;
  }
  const removeLink = event.target.closest('.drawer-remove');
  if (removeLink) {
    event.preventDefault();
    await fetch(removeLink.href);
    await refreshCartDrawer();
    openCartDrawer();
  }
});

document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeCartDrawer(); });

document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const submit = form.querySelector('[type="submit"]');
    if (submit) submit.disabled = true;
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Unable to add this treasure.');
      await refreshCartDrawer();
      openCartDrawer();
    } catch (error) {
      window.alert(error.message);
    } finally {
      if (submit) submit.disabled = false;
    }
  });
});

const searchShell = document.querySelector('.search-overlay-shell');
const searchInput = document.querySelector('#OverlaySearchInput');
const searchResults = document.querySelector('.predictive-results');
const searchAllLink = document.querySelector('.search-all-link');
const searchHint = document.querySelector('[data-search-hint]');
const openSearch = () => {
  menuButton?.setAttribute('aria-expanded', 'false');
  siteNav?.classList.remove('is-open');
  document.body.classList.add('search-overlay-open');
  window.setTimeout(() => searchInput?.focus(), 80);
};
const closeSearch = () => document.body.classList.remove('search-overlay-open');
let searchTimer;

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('.search-trigger');
  if (trigger && !event.ctrlKey && !event.metaKey) { event.preventDefault(); openSearch(); }
  if (event.target.closest('[data-search-close]')) closeSearch();
});
document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeSearch(); });

if (searchInput && searchResults) {
  searchInput.addEventListener('input', () => {
    window.clearTimeout(searchTimer);
    const query = searchInput.value.trim();
    searchAllLink.href = `/search?type=product&q=${encodeURIComponent(query)}`;
    if (query.length < 2) {
      searchResults.replaceChildren();
      if (searchHint) searchHint.textContent = 'Start typing to discover something magical.';
      return;
    }
    if (searchHint) searchHint.textContent = `Looking for treasures matching “${query}”…`;
    searchTimer = window.setTimeout(async () => {
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=hide`);
        const data = await response.json();
        const products = data.resources?.results?.products || [];
        if (searchHint) searchHint.textContent = products.length ? `Treasures matching “${query}.”` : `No treasures matched “${query}.”`;
        searchResults.replaceChildren();
        products.forEach((product) => {
          const card = document.createElement('a'); card.className = 'predictive-card'; card.href = product.url;
          if (product.featured_image?.url || product.image) { const img = document.createElement('img'); img.src = product.featured_image?.url || product.image; img.alt = product.featured_image?.alt || product.title; card.append(img); }
          const title = document.createElement('strong'); title.textContent = product.title; card.append(title);
          const price = document.createElement('span'); price.textContent = new Intl.NumberFormat(undefined, { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(Number(product.price)); card.append(price);
          searchResults.append(card);
        });
        if (!products.length) { const empty = document.createElement('p'); empty.className = 'predictive-empty'; empty.textContent = 'No tiny treasures found yet. Try another magical word.'; searchResults.append(empty); }
      } catch (_) { searchResults.textContent = 'Search is resting for a moment. Please try again.'; }
    }, 250);
  });
}

document.querySelectorAll('[data-tag-toggle]').forEach((toggle) => {
  const tagList = document.getElementById(toggle.getAttribute('aria-controls'));
  if (!tagList) return;
  const tags = [...tagList.querySelectorAll('.tag-pill')];
  tags.sort((a, b) => {
    if (a.classList.contains('is-active')) return -1;
    if (b.classList.contains('is-active')) return 1;
    return Number(b.dataset.tagCount || 0) - Number(a.dataset.tagCount || 0) || a.textContent.localeCompare(b.textContent);
  }).forEach((tag) => tagList.append(tag));
  toggle.addEventListener('click', () => {
    const expanded = tagList.classList.toggle('is-expanded');
    toggle.setAttribute('aria-expanded', String(expanded));
    toggle.textContent = expanded ? 'Show fewer tags' : 'Show all tags';
  });
});

document.querySelectorAll('.facets').forEach((form) => {
  form.querySelectorAll('select, input[type="checkbox"], input[type="number"]').forEach((control) => {
    control.addEventListener('change', () => form.requestSubmit());
  });
});

const defaultSortForm = document.querySelector('[data-default-sort]');
if (defaultSortForm) {
  const params = new URLSearchParams(window.location.search);
  const sortValue = defaultSortForm.dataset.defaultSort;
  const sortSelect = defaultSortForm.querySelector('select[name="sort_by"]');
  if (!params.has('sort_by') && sortSelect?.querySelector(`option[value="${sortValue}"]`)) {
    params.set('sort_by', sortValue);
    window.location.replace(`${window.location.pathname}?${params.toString()}${window.location.hash}`);
  }
}

const productForm = document.querySelector('[data-product-form]');
const productSubmit = productForm?.querySelector('.product-submit');
const stickyProductBar = document.querySelector('[data-mobile-product-bar]');
const stickyProductSubmit = stickyProductBar?.querySelector('[data-sticky-product-submit]');
const stickyPrice = stickyProductBar?.querySelector('[data-sticky-price]');

if (productForm && productSubmit && stickyProductBar && stickyProductSubmit) {
  stickyProductSubmit.addEventListener('click', () => productForm.requestSubmit(productSubmit));
  const updateStickyVisibility = (visible) => {
    stickyProductBar.classList.toggle('is-visible', visible);
    stickyProductBar.setAttribute('aria-hidden', String(!visible));
    stickyProductSubmit.tabIndex = visible ? 0 : -1;
  };
  const mobileQuery = window.matchMedia('(max-width: 600px)');
  const observer = new IntersectionObserver(([entry]) => updateStickyVisibility(mobileQuery.matches && !entry.isIntersecting), { threshold: 0.15 });
  observer.observe(productSubmit);
  mobileQuery.addEventListener?.('change', (event) => { if (!event.matches) updateStickyVisibility(false); });
  variantSelect?.addEventListener('change', () => {
    const price = variantSelect.selectedOptions[0]?.dataset.price;
    if (price && stickyPrice) stickyPrice.textContent = price;
  });
}

const currentProductData = document.querySelector('[data-current-product]');
const productTagsData = document.querySelector('[data-product-tags]');
const recentSection = document.querySelector('[data-recently-viewed]');
const recentGrid = document.querySelector('[data-recent-grid]');
const relatedSection = document.querySelector('[data-related-products]');
const relatedGrid = document.querySelector('[data-related-grid]');

const formatDiscoveryMoney = (value) => {
  if (typeof value === 'string' && /[$£€]/.test(value)) return value;
  return new Intl.NumberFormat(undefined, { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(Number(value || 0));
};

const createDiscoveryCard = (product) => {
  const article = document.createElement('article');
  article.className = 'product-card';
  const imageLink = document.createElement('a');
  imageLink.className = 'product-card-image';
  imageLink.href = product.url;
  const imageUrl = product.image || product.featured_image?.url || product.featured_image;
  if (imageUrl) {
    const image = document.createElement('img');
    image.src = imageUrl;
    image.alt = product.featured_image?.alt || product.title;
    image.loading = 'lazy';
    imageLink.append(image);
  }
  const info = document.createElement('div');
  info.className = 'product-card-info';
  const titleWrap = document.createElement('div');
  const heading = document.createElement('h3');
  const titleLink = document.createElement('a');
  titleLink.href = product.url;
  titleLink.textContent = product.title;
  heading.append(titleLink);
  titleWrap.append(heading);
  const price = document.createElement('strong');
  price.textContent = formatDiscoveryMoney(product.price);
  info.append(titleWrap, price);
  article.append(imageLink, info);
  return article;
};

if (currentProductData) {
  try {
    const current = JSON.parse(currentProductData.textContent);
    const storageKey = 'robotBelleRecentlyViewed';
    const stored = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
    const previous = stored.filter((item) => String(item.id) !== String(current.id)).slice(0, 4);
    if (previous.length && recentGrid && recentSection) {
      previous.forEach((product) => recentGrid.append(createDiscoveryCard(product)));
      recentSection.hidden = false;
    }
    window.localStorage.setItem(storageKey, JSON.stringify([current, ...stored.filter((item) => String(item.id) !== String(current.id))].slice(0, 12)));
  } catch (_) {
    // Browsing still works if storage is unavailable.
  }
}

if (currentProductData && productTagsData && relatedGrid && relatedSection) {
  try {
    const current = JSON.parse(currentProductData.textContent);
    const ignoredTags = new Set(['pin', 'pins', 'official disney pins', 'disney licensed pins', 'disney-licensed pins', 'fantasy pins', 'non-pin treasures']);
    const tags = JSON.parse(productTagsData.textContent).filter((tag) => !ignoredTags.has(String(tag).toLowerCase())).slice(0, 6);
    const root = window.Shopify?.routes?.root || '/';
    Promise.all(tags.map(async (tag) => {
      const query = `tag:"${String(tag).replaceAll('"', '')}"`;
      const response = await fetch(`${root}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide`);
      if (!response.ok) return [];
      const data = await response.json();
      return data.resources?.results?.products || [];
    })).then((groups) => {
      const seen = new Set([String(current.url).split('?')[0]]);
      const related = [];
      groups.flat().forEach((product) => {
        const key = String(product.url).split('?')[0];
        if (!seen.has(key) && related.length < 4) { seen.add(key); related.push(product); }
      });
      if (related.length) {
        related.forEach((product) => relatedGrid.append(createDiscoveryCard(product)));
        relatedSection.hidden = false;
      }
    }).catch(() => {});
  } catch (_) {
    // Recommendations remain hidden if Shopify cannot return a match.
  }
}

const openPolicyFromHash = () => {
  if (!window.location.hash) return;
  const target = document.querySelector(window.location.hash);
  if (target?.matches('details.policy-card')) target.open = true;
};
openPolicyFromHash();
window.addEventListener('hashchange', openPolicyFromHash);
